export default __webpack_public_path__ + "static/media/chevron-left-disabled.12290562.svg";